import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

/**
 * Add a custom examination item to the Events Plan Exam section.
 */
const AddExamModal = ({ open, onClose, onAdd, existingNames = [] }) => {
  const { control, handleSubmit, reset, setError, clearErrors, formState } = useForm({
    defaultValues: { name: "" },
  });

  useEffect(() => {
    if (open) reset({ name: "" });
  }, [open, reset]);

  const submit = handleSubmit(({ name }) => {
    const trimmedName = String(name || "").trim();
    if (!trimmedName) {
      setError("name", { type: "required", message: "Please enter an examination name" });
      return;
    }
    const isDuplicate = existingNames.some(
      (n) => String(n || "").toLowerCase() === trimmedName.toLowerCase(),
    );
    if (isDuplicate) {
      setError("name", { type: "validate", message: "This examination already exists" });
      return;
    }

    onAdd({
      name: trimmedName,
      rationale: "Added manually",
      isCustom: true,
    });
    reset({ name: "" });
    onClose();
  });

  const handleClose = () => {
    reset({ name: "" });
    clearErrors();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Examination</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          Add an examination finding or maneuver to consider for this differential.
        </DialogContentText>
        <Controller
          name="name"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              autoFocus
              label="Examination name"
              placeholder="e.g., Orthostatic vital signs"
              fullWidth
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message || ""}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  submit();
                }
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={submit} variant="contained" disabled={formState.isSubmitting}>
          Add to Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddExamModal;
